// @flow

import React, { type Node } from 'react';
import { useUniqueId } from '@tectonics/hooks';
import { Label, TextField } from '../../../../../../commons/atoms';
import { InputGroup } from '../../../../../../commons/molecules';
import { useUserInputAsTextField } from '@tectonics/prs/user-input-values';
import { useSubmitting } from '@tectonics/prs/submitting';

export function InputBrazilianStreetComplement(): Node {
  const [value, handleChange] = useUserInputAsTextField('brazilianStreetComplement');
  const inputId = useUniqueId();
  const submitting = useSubmitting();

  return (
    <div data-test-name="address-street-complement">
      <InputGroup
        label={<Label htmlFor={inputId}>Complemento</Label>}
        input={
          <TextField
            id={inputId}
            value={value}
            onChange={handleChange}
            readOnly={submitting}
            name="address-street-complement"
          />
        }
      />
    </div>
  );
}
